export enum ConversationMessageStatus {
    Thinking = "Thinking",
    Streaming = "Streaming",
    Completed = "Completed",
    Error = "Error",
    Cancelled = "Cancelled",
    MaxLengthReached = "MaxLengthReached",
    UpdatingFeedback = "UpdatingFeedback",
}
